export default "__VITE_ASSET__CfgiT9sV__"